import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import LogSap from "./LogSap";
import LogProspekt from "./LogProspekt";
import LogLocal from "./LogLocal";

import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { updateObject } from "../../../helpers/updateObject";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    width: "-webkit-fill-available",
  },
}));

export default function Employers(props) {
  const {
    chooseDevicePlaceId,
    setChooseDevicePlaceId,
    showLog,
    setShowLog,
  } = props;

  const [value, setValue] = React.useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [logRows, setLogRows] = useState([]);
  const [logLocalRows, setLogLocalRows] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(100);
  const [count, setCount] = useState(0);
  const [countLocal, setCountLocal] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();

  // const onLogRows = () => {
  //   setIsLoading(true);

  //   axios
  //     .get(
  //       `${
  //         process.env.REACT_APP_API_URL
  //       }structure/device-place/${chooseDevicePlaceId}?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}`
  //     )
  //     .then(({ data: { content, totalElements } }) => {
  //       setIsLoading(false);
  //       setLogRows(content);
  //       setIsError(false);
  //       setCount(totalElements);
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //       setIsError(true);
  //       setLogRows([]);
  //     });
  // };
  const onLogLocalRows = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure-local/device-place/${chooseDevicePlaceId}?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}`
      )
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setLogLocalRows(content);
        setIsError(false);
        setCountLocal(totalElements);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
        setLogRows([]);
      });
  };

  // useEffect(() => {
  //   if (showLog) {
  //     onLogRows(orderBy, sortField, skip, take);
  //     onLogLocalRows(orderBy, sortField, skip, take);
  //   }
  // }, [orderBy, sortField, skip, take, showLog]);

  return (
    <Modal
      show={showLog}
      onHide={setShowLog}
      size="xl"
      aria-labelledby="edit"
      centered
      className="pr-0 ModalSize"
    >
      <Modal.Header closeButton>
        <Modal.Title id="delete">Strukturlar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row bg-white rounded  mt-6 mb-6">
          <div className={classes.root}>
            <AppBar position="static">
              <Tabs value={value} onChange={handleChange}>
                <Tab label="DaxİLİ" />
                {/* <Tab label="Prospekt" />
                <Tab label="DaxİLİ" /> */}
              </Tabs>
            </AppBar>
            {value === 0 && (
              <TabContainer>
                <LogSap
                  chooseDevicePlaceId={chooseDevicePlaceId}
                  setChooseDevicePlaceId={setChooseDevicePlaceId}
                  isLoading={isLoading}
                  isError={isError}
                  setSortField={setSortField}
                  setOrderByTable={setOrderBy}
                  sortField={sortField}
                  orderBy={orderBy}
                  count={count}
                  updateSkip={setSkip}
                  updateTake={setTake}
                  skip={skip}
                  take={take}
                  setIsLoading={setIsLoading}
                  setIsError={setIsError}
                  setCount={setCount}
                  showLog={showLog}
                />
              </TabContainer>
            )}
            {value === 1 && (
              <TabContainer>
                <LogProspekt
                  chooseDevicePlaceId={chooseDevicePlaceId}
                  setChooseDevicePlaceId={setChooseDevicePlaceId}
                  isLoading={isLoading}
                  isError={isError}
                  logRows={logRows}
                  setSortField={setSortField}
                  setOrderByTable={setOrderBy}
                  sortField={sortField}
                  orderBy={orderBy}
                  count={count}
                  updateSkip={setSkip}
                  skip={skip}
                  take={take}
                  updateTake={setTake}
                  setIsLoading={setIsLoading}
                  setIsError={setIsError}
                  setCount={setCount}
                  showLog={showLog}
                />
              </TabContainer>
            )}
            {value === 2 && (
              <TabContainer>
                <LogLocal
                  chooseDevicePlaceId={chooseDevicePlaceId}
                  setChooseDevicePlaceId={setChooseDevicePlaceId}
                  isLoading={isLoading}
                  isError={isError}
                  logLocalRows={logLocalRows}
                  setSortField={setSortField}
                  setOrderByTable={setOrderBy}
                  sortField={sortField}
                  orderBy={orderBy}
                  count={countLocal}
                  updateSkip={setSkip}
                  updateTake={setTake}
                  skip={skip}
                  take={take}
                  onLogLocalRows={onLogLocalRows}
                />
              </TabContainer>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
